import { Box, TableContainer } from "@mui/material";
import { styled } from "@mui/system";
import { Colors } from "../theme/index";



export const CommanTableContain = styled(TableContainer)(() => ({
  maxHeight: "400px", 
  border: "1px solid rgba(224, 224, 224, 1)", 
  borderRadius: "5px", 
  overflowY: "auto", 
  overflowX: "auto",
 
 
  "& table": {
    width: "100%", 
    borderCollapse: "collapse", 
  },
  "& table tr th,& table tr td": {
    borderRight: "1px solid rgba(224, 224, 224, 1)",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    borderLeft: "none",
    borderTop: "none", // Remove the top border
    textAlign: "center",
    
  },
  "& table thead tr:first-of-type th": {
    borderTop: "none", // Remove the top border for the header row
    // backgroundColor: "blue", // Ensure the header has a solid background color
    color: Colors.black,
     
    backgroundColor: "#bec4cb",
    whiteSpace: "nowrap",
    position: "sticky", // Make the header sticky
    top: 0, // Stick to the top
    zIndex: 3, 
    fontWeight: "bold",// Ensure it stays above other elements
    "& span": {
      fontSize: "12px",
      display: "block",
    },
  },
  "& table tr td:first-of-type, & table tr th:first-of-type": {
    position: "sticky",
    left: 0, 
    zIndex: 4,
    backgroundColor: "white",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    borderRight: "1px solid rgba(224, 224, 224, 1)",
    borderTop: "none", 
    

    
   
  },
  "& table thead tr:first-of-type th:first-of-type": {
    position: "sticky",
    left: 0, 
    top: 0, 
    zIndex: 5, 
    backgroundColor: "#bec4cb",
    
  },

  "& table tr td": {
    backgroundcolor: Colors.text,
    padding: "7px",
    "& button.action": {
      color: Colors.grayText,
      border: "none",
      outline: "none",
      padding: "7px 15px",
      borderRadius: "5px",
      fontSize: "12px",
      height: "30px",
      "&.save": {
        color: Colors.text,
        backgroundColor: "#009000",
      },
    },
    "& a": {
      fontSize: "12px",
      color: "#007FFF",
    },
    "& input,& textarea, & select": {
      fontSize: "12px",
      width: "100%",
      padding: "5px",
      borderRadius: "5px",
    },
    "& .MuiStack-root": {
      padding: "0",
      "& .MuiFormControl-root": {
        minWidth: "150px",
        maxWidth: "150px",
        margin: "auto",
        border: "1px solid rgba(0, 0, 0, 0.23)",
        borderRadius: "5px",
        "& label": {
          fontSize: "11px",
          top: "-5px",
        },
        "& .MuiInputBase-input": {
          padding: "9px 14px",
          height: "auto",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          display: "none",
        },
      },
    },
  },
  "& table tr:last-of-type td": {
    borderBottom: "1px solid rgba(224, 224, 224, 1)", 
  },
  "& table tr": {
    "&:hover": {
      "& td.Form_accepted,& td.Form_submitted": {
        backgroundColor: Colors.formAcceptedBg,
      },
      "& td.Form_in-process,& td.Form_reconsideration": {
        backgroundColor: Colors.formInprocessBg,
      },
      "& td.Form_pending": {
        backgroundColor: Colors.formInprocessBg,
      },
    },
    "& td": {
      "&.Form_accepted,&.Form_submitted": {
        color: Colors.formAccepted,
      },
      "&.Form_in-process,&.Form_reconsideration": {
        color: Colors.formInprcess,
      },
      "&.Form_pending": {
        color: Colors.formPending,
      },
    },
  },

  "& .icon-done": {
    color: "green",
    cursor: "pointer",
    fontSize: "20px", // Adjust the size if needed
  },
  "& .icon-close": {
    color: "red",
    cursor: "pointer",
    fontSize: "20px", // Adjust the size if needed
  },
  "& .icon-edit": {
    color: "blue",
    cursor: "pointer",
    fontSize: "20px", // Adjust the size if needed
  },
  "& .icon-delete": {
    color: "red",
    cursor: "pointer",
    fontSize: "20px", // Adjust the size if needed
  },
}));

export const StyledTableBox = styled(Box)(() => ({
  backgroundColor: Colors.primary,
  padding: '16px 24px',
  color: 'white',
  position: 'relative',
  zIndex: 1,
  borderRadius: '16px 16px 0 0',
  marginBottom: 'none',
}));
 

export const PaginationContain = styled(Box)(() => ({
  position: "sticky",
  borderBottom: "1px solid rgba(224, 224, 224, 1)",
  borderRight: "1px solid rgba(224, 224, 224, 1)",
  borderLeft: "1px solid rgba(224, 224, 224, 1)",
  // Add a border around the entire pagination
   // Optional: Add rounded corners
  padding: "0.2px 0",
   // Reduce vertical padding to decrease height
  "& .MuiTablePagination-select": {
    zIndex: 11,
  },
}));

export const CardHeader = styled(Box)({
  backgroundColor: Colors.primary,
  
  padding: '16px 24px',
  color: 'white',
  position: 'relative',
  zIndex: 1,
  borderRadius: '16px 16px 0 0',
  position: 'sticky',
  marginBottom: 'none',
});